/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {EditV2GoalRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {EditV2GoalResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const editV2Goal = (request: EditV2GoalRequest, options?: CashRequestOptions) => post<EditV2GoalRequest, EditV2GoalResponse>("/2.0/cash/edit-v2-goal", request, {...options, rejectOnError: true })